// extracted by mini-css-extract-plugin
export default {"wrap":"Seighth_wrap__-w27n","item":"Seighth_item__tt4jb","item_title":"Seighth_item_title__8Jp9t","item_desc":"Seighth_item_desc__k2Xcu","Seighth":"Seighth_Seighth__ivS2o"};